import React from 'react'
import HeaderOne from '../Components/Header/HeaderOne'
import Breadcrumb from '../Components/BreadCrumb/Breadcrumb'
import CheckoutInner from '../Components/Shop/CheckoutInner'
import FooterFour from '../Components/Footer/FooterFour'
import ScrollToTop from '../Components/ScrollToTop'
import SEO from '../Components/SEO/SEO'

function Checkout() {
    return (
        <>
            <SEO 
                title="Checkout - Tourm Travel Shop"
                description="Complete your purchase and checkout."
                url="/checkout"
            />
            <HeaderOne />
            <Breadcrumb
                title='Checkout'
            />
            <CheckoutInner />
            <FooterFour/>
            <ScrollToTop />
        </>
    )
}

export default Checkout
